import { render, staticRenderFns } from "./TableButton.vue?vue&type=template&id=0cb271c0&scoped=true"
import script from "./TableButton.vue?vue&type=script&lang=js"
export * from "./TableButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb271c0",
  null
  
)

export default component.exports